import PropTypes from 'prop-types';
import DelayActionMetadata from 'automation-ui-action-features/actions/delay/records/DelayActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import DelayActionDetail from 'automation-ui-action-features/actions/delay/DelayActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const DelayActionHistoryCard = ({
  actionMetadata,
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(DelayActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
DelayActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(DelayActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default DelayActionHistoryCard;